import QuantificationGridHeader from "@components/DataGrid/components/headers/QuantificationGridHeader";
import i18n from "@i18n/i18n";

export const getDynamicColumns = (kind?: string | null) => {
  /*
    ICT v1 columns
    { "Name", row.Name },
    { "Source", row.Source },
  */

  /*
    Veracity v1 columns
    { "MPA", row.MPA },
    { "Veracity ID", row.ObjectId },
    { "Reference Period", row.ReferencePeriod },
    { "Location", row.Location }
  */
  const veracityV1Columns = [
    {
      field: "veracity-v1.mpa",
      headerName: i18n.t("assign-grid.dynamic-columns.veracity-v1.mpa"),
      renderHeader: () => <QuantificationGridHeader name={i18n.t("assign-grid.dynamic-columns.veracity-v1.mpa")} />,
      flex: 1,
      valueGetter: (_value: any, row: any) => {
        return row.data?.co2MaterialTypeSpec?.Co2MaterialTypes?.[0].SourceData?.["MPA"] || "";
      },
    },
    {
      field: "veracity-v1.veracity-id",
      headerName: i18n.t("assign-grid.dynamic-columns.veracity-v1.veracity-id"),
      renderHeader: () => <QuantificationGridHeader name={i18n.t("assign-grid.dynamic-columns.veracity-v1.veracity-id")} />,
      flex: 1,
      valueGetter: (_value: any, row: any) => {
        return row.data?.co2MaterialTypeSpec?.Co2MaterialTypes?.[0].SourceData?.["Veracity ID"] || "";
      },
    },
    {
      field: "veracity-v1.reference-period",
      headerName: i18n.t("assign-grid.dynamic-columns.veracity-v1.reference-period"),
      renderHeader: () => <QuantificationGridHeader name={i18n.t("assign-grid.dynamic-columns.veracity-v1.reference-period")} />,
      flex: 1,
      valueGetter: (_value: any, row: any) => {
        return row.data?.co2MaterialTypeSpec?.Co2MaterialTypes?.[0].SourceData?.["Reference Period"] || "";
      },
    },
    {
      field: "veracity-v1.location",
      headerName: i18n.t("assign-grid.dynamic-columns.veracity-v1.location"),
      renderHeader: () => <QuantificationGridHeader name={i18n.t("assign-grid.dynamic-columns.veracity-v1.location")} />,
      flex: 1,
      valueGetter: (_value: any, row: any) => {
        return row.data?.co2MaterialTypeSpec?.Co2MaterialTypes?.[0].SourceData?.["Location"] || "";
      },
    },
  ];

  const dynamicColumnsMap = {
    "Veracity v1": {
      columns: veracityV1Columns,
    },
    // Future material type spec kinds can be added here
  };

  const dynamicColumns = kind && dynamicColumnsMap[kind as keyof typeof dynamicColumnsMap] ? dynamicColumnsMap[kind as keyof typeof dynamicColumnsMap].columns : [];
  return dynamicColumns;
};
